export default "__VITE_ASSET__BdSDxhoX__"